import { useEffect, useRef, useState } from "react";
import { GeoLocation } from "../../models/GeoLocation";
import { Option } from "../../models/SelectInputs";
import { ReactComponent as SearchIcon } from '../../assets/svg/search.svg';
import { ReactComponent as CheckMark } from '../../assets/svg/checkmark.svg';
import { ReactComponent as CloseCircle } from '../../assets/svg/close-circle.svg';
import { DropdownItem } from "../Shared/DropdownItem";

interface Props {
    styles: any;
    locations: GeoLocation[];
    selectOption(locationId: number): void;
}
export const MobileLocationSelect: React.FC<Props> = (props) => {
    const styles = props.styles;
    const [options, setOptions] = useState<Option[]>([]);
    const [filteredOptions, setFilteredOptions] = useState<Option[]>([]);
    const inputRef = useRef<HTMLInputElement>(null);
    const [hoveredIndex, setHoveredIndex] = useState<number>(-1);
    const [searchKeyword, setSearchKeyword] = useState<string>("");

    useEffect(() => {
        generateLocationOptions();
    }, [props.locations])

    const filterOptions = (keyword: string) => {
        setSearchKeyword(keyword);
        var tempOptions = options.filter(x => x.option.toUpperCase().includes(keyword.toUpperCase()));
        setFilteredOptions(tempOptions);
    }

    const generateLocationOptions = () => {
        let tempOptions: Option[] = [];
        props.locations.forEach((location) => {
            let option: Option = {
                value: location.locationId,
                option: location.locationName,
                checked: location.isSelected
            }
            tempOptions.push(option);    
        })
        setOptions(tempOptions);
        setFilteredOptions(tempOptions);
    }

    const focusInput = (event: React.MouseEvent) => {
        event.stopPropagation()
        if (inputRef.current) {
          inputRef.current.focus();
        }
    };

    return (
        <div style={{...styles.wrapper, ...styles.wrapper.location}}>
            <input type="text" ref={inputRef} style={styles.search} placeholder={"Search"} onClick={e => {e.stopPropagation()}} onChange={(e) => filterOptions(e.target.value)}/>
            {searchKeyword === "" && <SearchIcon style={styles.search.icon} onClick={(e) => focusInput(e)} />}
            <CloseCircle style={styles.closeButton}/>
            <div className="scrollArea optionSelectScroll" style={styles.scrollArea}>
                {filteredOptions.map((option, index) =>
                    <div
                        key={index}
                        onMouseEnter={() => { setHoveredIndex(index); }}
                        onMouseLeave={() => { setHoveredIndex(-1); }}
                    >
                        <DropdownItem key={index} styles={styles.option} onClick={() => props.selectOption(option.value as number)}>
                            {option.checked ? <CheckMark style={styles.checkMark} />
                                : <div style={styles.checkbox}></div>}
                            <label style={styles.optionLabel}>{option.option}</label>
                        </DropdownItem>
                        <hr style={{ ...styles.bottomBorder, ...((hoveredIndex === index || hoveredIndex === index + 1 || filteredOptions.length === index + 1) && styles.hoveredBorder) }} />
                    </div>
                )}
            </div>
        </div>
    )
}